import { useState } from "react";
import Sidebar from "./Sidebar";
import TopNavbar from "./TopNavbar";
import AppRoutes from "./AppRoutes";
import useGeneralStore from "store/general";
import useInitializeApp from "hooks/useInitializeApp";
import Loading from "components/Loading";
import GlobalModalManager from "components/ui/GlobalModalManager";

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { sidebarCollapsed } = useGeneralStore();

  // Initialize app data (company preferences, etc.)
  const { isInitialized, isLoading, error } = useInitializeApp();

  // Show loading screen while initializing
  if (isLoading && !isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  // Show error screen if initialization failed
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-4">⚠️</div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Failed to load application
          </h2>
          <p className="text-gray-600 mb-4">
            Unable to load company preferences. Please try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div>
        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        {/* Main content area */}
        <div
          className={`transition-all duration-300 ${
            sidebarCollapsed ? "lg:pl-16" : "lg:pl-72"
          }`}
        >
          {/* Top Navigation */}
          <TopNavbar setSidebarOpen={setSidebarOpen} />

          {/* Main content - max height calculated as screen height minus navbar (h-16 = 4rem) */}
          <main className="py-10 min-h-[calc(100vh-4rem)] max-h-[calc(100vh-4rem)] overflow-x-auto overflow-y-auto">
            <AppRoutes />
          </main>
        </div>

        {/* Global Modal Manager - renders modals based on store state */}
        <GlobalModalManager />
      </div>
    </>
  );
}
